import type { CatalogueConfiguration, CatalogueType as CatalogueTypeFromConfig } from '@/config/types'
import { CatalogueType } from '@/scopes/common/domain/enums/CatalogueType'

export function getCatalogueType(params?: {
  url?: string
  catalogueList?: Partial<Record<CatalogueTypeFromConfig, CatalogueConfiguration>>
}): CatalogueType {
  const { url, catalogueList } = params || {}

  if (!url) {
    return CatalogueType.None
  }

  if (url?.includes(`${catalogueList?.summer?.urlMatcher}/`) || url === catalogueList?.summer?.urlMatcher) {
    return CatalogueType.Summer
  }

  if (url?.includes(`${catalogueList?.winter?.urlMatcher}/`) || url === catalogueList?.winter?.urlMatcher) {
    return CatalogueType.Winter
  }

  return CatalogueType.None
}
